import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { ProductTitleService } from '@core/text/product-title';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { DataLayerService } from '@core/analytics/data-layer.service';
import { GtmLoaderService } from '@core/analytics/gtm-loader.service';
import { AuthService } from '@core/auth/auth.service';
import { authInterceptor } from '@core/http/auth.interceptor';
import { errorInterceptor } from '@core/http/error.interceptor';
import { MembresiasContentSource } from '@core/membresias/membresias-content.source';
import { StaticMembresiasContentSource } from '@core/membresias/static-membresias-content.source';
import { routerFeatures, routerProviders } from '@core/router/router.providers';
import { BackNavigationService } from '@core/router/back-navigation.service';
import { SegmentBrandingService } from '@core/theme/segment-branding.service';
import { ThemeConfigService } from '@core/theme/theme-config.service';
import { APP_ROUTES } from './app.routes';
import { activeThemeConfig } from './theme-selection';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES, ...routerFeatures),
    { provide: MembresiasContentSource, useExisting: StaticMembresiasContentSource },
    ...routerProviders,
    // Registrar el listado antes de que un detalle solicite el servicio por primera vez.
    provideAppInitializer(() => {
      inject(BackNavigationService);
    }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAppInitializer(() => inject(ThemeConfigService).apply(activeThemeConfig)),
    // Justo despues del tema del tenant y antes del primer frame: sin esto la
    // tienda se pinta con el navy base y salta al color del socio cuando responde
    // el perfil, que es el parpadeo que se veia al entrar.
    provideAppInitializer(() => inject(SegmentBrandingService).restaurarDesdeCache()),
    provideAppInitializer(() => inject(AuthService).loadSession()),
    // Antes de la primera card: las reglas de escritura de los títulos pueden venir del CMS.
    provideAppInitializer(() => inject(ProductTitleService).cargarDesdeCms()),
    provideAppInitializer(() => {
      inject(GtmLoaderService).start();
      inject(DataLayerService).bootstrap();
    }),
  ],
};
